<template>
  <div>
    <PageAllow controller="ShopCostAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetime
              type="month"
              v-model="datetimeRage"
              :label="$t('ShopCostMonthlyAnalyze.createdMonth')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <!-- 导出 按钮 -->
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'ShopCostAnalyze',
                  'exportForMaterial'
                )
              "
              small
              color="print"
              dark
              class="ms-1"
              @click.stop="Export()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("MaterialDistribution.Export.excel") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearchShop v-model="shopSelected" :districtID="districtID" />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="shopSelected">
                <SearcherKeyword
                  ref="keyword"
                  v-model="options.cost_analyze_code"
                  @text="costAnalyzeCode = $event"
                  :label="$t('materialAnalyze.cost_analyze_code')"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="material_cost_analyzes"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <!-- 商品名称 -->
          <template v-slot:item.material_name="{ item }">
            <a
              class="text-no-wrap"
              @click.stop="
                materialDetailsDialog = true;
                material_id = item.material_id;
              "
            >
              {{ item.material_name }}
            </a>
          </template>
          <!-- 理论成本数量 / 金额 -->
          <template v-slot:item.theory_gross_weight="{ item }">
            {{ item.theory_gross_weight | formatTwoDot(true)
            }}{{ $t("Global.gram") }}
            /
            {{ $t("Global.money") }}{{ item.theory_total_price | formatMoney }}
          </template>
          <!-- 实际成本数量 / 金额 -->
          <template v-slot:item.actual_gross_weight="{ item }">
            {{ item.actual_gross_weight | formatTwoDot(true)
            }}{{ $t("Global.gram") }}
            /
            {{ $t("Global.money") }}{{ item.actual_total_price | formatMoney }}
          </template>
          <!-- 差异量 / 金额 -->
          <template v-slot:item.loss_gross_weight="{ item }">
            {{
              (item.actual_gross_weight - item.theory_gross_weight)
                | formatTwoDot(true)
            }}{{ $t("Global.gram") }}
            /
            {{ $t("Global.money")
            }}{{
              (item.actual_total_price - item.theory_total_price) | formatMoney
            }}
          </template>
          <!-- 差异率 -->
          <template v-slot:item.loss_rate="{ item }">
            {{
              ((item.theory_gross_weight == 0
                ? 0
                : (item.actual_gross_weight - item.theory_gross_weight) /
                  item.theory_gross_weight) *
                100)
                | formatTwoDot(true)
            }}{{ $t("Global.rate") }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="materialDetailsDialog" max-width="800px">
      <v-card height="400px">
        <v-card-text>
          <v-container>
            <v-data-table
              :headers="foodDetailsHeaders"
              :items="foods"
              multi-sort
              disable-pagination
              hide-default-footer
              :no-data-text="
                $t('ShopCostMonthlyAnalyze.DetailFields.DetailNoData')
              "
            >
              <!-- 销售量 -->
              <template v-slot:item.total_sale_num="{ item }">
                {{ item.total_sale_num | formatTwoDot(true)
                }}{{ item.food_unit }}
              </template>
              <!-- 理论成本数量 / 金额 -->
              <template v-slot:item.total_theory_gross_weight="{ item }">
                {{ item.total_theory_gross_weight | formatTwoDot(true)
                }}{{ $t("Global.gram") }}
                /
                {{ $t("Global.money")
                }}{{ item.theory_total_price | formatMoney }}
              </template>
              <!-- 实际成本数量 / 金额 -->
              <template v-slot:item.total_actual_gross_weight="{ item }">
                {{ item.total_actual_gross_weight | formatTwoDot(true)
                }}{{ $t("Global.gram") }}
                /
                {{ $t("Global.money")
                }}{{ item.actual_total_price | formatMoney }}
              </template>
              <!-- 差异量 / 金额 -->
              <template v-slot:item.loss_gross_weight="{ item }">
                {{
                  (item.total_actual_gross_weight -
                    item.total_theory_gross_weight)
                    | formatTwoDot(true)
                }}{{ $t("Global.gram") }}
                /
                {{ $t("Global.money")
                }}{{
                  (item.actual_total_price - item.theory_total_price)
                    | formatMoney
                }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
</style>
<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearchShop from "@/components/shopCostAnalyze/plugins/SearchShop";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import shopCostAnalyze from "@/api/shop_cost_analyze";

const defaultOptions = {
  created_month: new Date().toISOString().substr(0, 7),
  shop_id: null,
  cost_analyze_code: "",
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    SearchShop,
    SearcherKeyword,
  },
  mounted() {
    this.$store.commit("districtID", 0);
    this.$store.commit("searchDistrict", true);
    this.$commonUtils
      .loadOptions("MaterialAnalyze", ["shopSelected", "datetimeRage"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopSelected":
                this.shopSelected = selected.value;
                break;
              case "datetimeRage":
                this.datetimeRage = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  data: () => ({
    datetimeRage: new Date().toISOString().substr(0, 7),
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopSelected: null,
    material_cost_analyzes: [],
    costAnalyzeCode: "",
    paging: {},
    materialDetailsDialog: false,
    foods: [],
    material_id: null,
  }),
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialCostAnalyze"),
          disabled: true,
        },
        // {
        //   text: i18n.t("materialAnalyze.title"),
        //   disabled: true,
        // },
      ];
    },
    headers() {
      var headers = [
        {
          text: i18n.t("materialAnalyze.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.theory_gross_weight"),
          align: "start",
          sortable: false,
          value: "theory_gross_weight",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.actual_gross_weight"),
          align: "start",
          sortable: false,
          value: "actual_gross_weight",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.loss_gross_weight"),
          align: "start",
          sortable: false,
          value: "loss_gross_weight",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.Fields.loss_rate"),
          align: "start",
          sortable: false,
          value: "loss_rate",
          class: "caption",
          cellClass: "caption",
        },
      ];
      return headers;
    },
    foodDetailsHeaders() {
      return [
        {
          text: i18n.t("materialAnalyze.DetailFields.food_code"),
          align: "start",
          sortable: false,
          value: "food_code",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.DetailFields.food_name"),
          align: "start",
          sortable: false,
          value: "food_name",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.DetailFields.food_behavior_name"),
          align: "start",
          sortable: false,
          value: "food_behavior_name",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.DetailFields.total_sale_num"),
          align: "start",
          sortable: false,
          value: "total_sale_num",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t(
            "materialAnalyze.DetailFields.total_theory_gross_weight"
          ),
          align: "start",
          sortable: false,
          value: "total_theory_gross_weight",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t(
            "materialAnalyze.DetailFields.total_actual_gross_weight"
          ),
          align: "start",
          sortable: false,
          value: "total_actual_gross_weight",
          class: "caption",
          cellClass: "caption",
        },
        {
          text: i18n.t("materialAnalyze.DetailFields.loss_gross_weight"),
          align: "start",
          sortable: false,
          value: "loss_gross_weight",
          class: "caption",
          cellClass: "caption",
        },
      ];
    },
    ...mapState(["settings", "loading", "districtID"]),
  },
  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        cost_analyze_code: this.costAnalyzeCode,
      });
    },
    resetSearch() {
      this.shopSelected = null;
      this.datetimeRage = new Date().toISOString().substr(0, 7);
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getMaterialAnalyzesFromAPI() {
      shopCostAnalyze.fetchMaterial(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.material_cost_analyzes = response.data.material_cost_analyzes;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    getMaterialAnalyzesDetailFromAPI() {
      shopCostAnalyze
        .fetchMaterialDetail(
          Object.assign({}, this.options, { material_id: this.material_id })
        )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.foods = response.data.foods;
            }
          }.bind(this)
        );
    },
    Export() {
      shopCostAnalyze.Exports(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        if (!this.shopSelected) {
          this.material_cost_analyzes = [];
          this.costAnalyzeCode = "";
        } else {
          this.getMaterialAnalyzesFromAPI();
        }
        sessionStorage.setItem(
          "MaterialAnalyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    materialDetailsDialog: {
      handler() {
        if (this.materialDetailsDialog) {
          this.getMaterialAnalyzesDetailFromAPI();
        }
      },
    },
    datetimeRage: {
      handler() {
        if (!this.datetimeRage) {
          this.datetimeRage = "";
        }
        this.options.created_month = this.datetimeRage;
        sessionStorage.setItem(
          "MaterialAnalyze-datetimeRage",
          JSON.stringify(this.datetimeRage)
        );
      },
    },
    shopSelected: {
      handler() {
        this.costAnalyzeCode = "";
        this.options.cost_analyze_code = "";
        this.options.shop_id = this.shopSelected ? this.shopSelected.id : null;
        sessionStorage.setItem(
          "MaterialAnalyze-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
  },
};
</script>
